export default "__VITE_ASSET__Bel2ObPW__"